/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import ReactDOM from 'react-dom';
import { unstable_HistoryRouter as HistRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import { BrowserHistory, createBrowserHistory } from 'history';

import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import customHistory from './utils/customRouter/CustomHistory';

document.getElementById('prepare-env')?.addEventListener('prepare-env-loaded', () => {
  const rootElement = document.getElementById('root');
  if (!rootElement) {
    throw new Error("Root element not found. Make sure index.html has a <div id='root'></div>");
  }
  const root = createRoot(rootElement);
  root.render(
    /* eslint-disable @typescript-eslint/no-explicit-any */

    <HistoryRouter history={customHistory as any}>
      <App />
    </HistoryRouter>,
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
